<template>
  <div class="warp">
    <div class="warp1">
      <div class="top">
        <div class="top_cent">
         <div class="top_p">
            <div class="top_cent_p">
              <i class="el-icon-location"></i>
              <el-dropdown trigger="click" class="koaa">
                <!-- <span class="el-dropdown-link" v-if="namee == ''">
              天津市
              <i class="el-icon-arrow-down el-icon--right"></i>
                </span>-->
                <span class="el-dropdown-link" v-if="getCitys[citr].city_name">
                  {{getCitys[citr].city_name}}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown" class="koa">
                  <el-dropdown-item
                    v-for="(item,index) in getCitys"
                    :key="index"
                    @click.native="dropdown(item.id,index)"
                  >{{item.city_name}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <i class="el-icon-arrow-down icon"></i> -->
            </div>
            <p>|</p>
            <p style="margin-top:2px;">
              <img src="../../assets/img/top_btn_home.png" alt />
            </p>
            <router-link :to="{name:'login'}" tag="p" style="padding:0;">
              <a href="#" class="aa">商企服首页</a>
            </router-link>
          </div>
          <ul class="top_ul">
            <li @click="dialogVisible = true">
              <a href="#">登录</a>
            </li>
            <li>|</li>
            <li @click="dialogVisible1 = true">
              <a href="#">注册</a>
            </li>
            <li>
              <a href="https://coc.sqifu.com" target="_blank">商会后台</a>
            </li>
            <router-link :to="{path:'/fuwushang'}" tag="li">
              <a href="#">卖家中心</a>
            </router-link>
            <li>
              <a href="http://zf.sqifu.com">政府机构</a>
            </li>
            <li>
              <i class="el-icon-phone"></i>022-8821-9596
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="banner">
      <img src="../../assets/img/guanyu/about_banner.png" alt />
      <div class="banner_1">
        <img src="../../assets/img/guanyu/sh_logo.png" alt />
        <p class="banner_p">基于商会的一站式企业服务平台</p>
        <p style="font-size:18px;">B2B+SAAS+商会=商企服AI</p>
      </div>
    </div>
    <!-- 内容 -->
    <div class="cent">
      <ul class="content_ul">
        <li :class="{active:0==numm}" @click="numm=0">
          <a href="#">关于我们</a>
        </li>
        <li :class="{active:1==numm}" @click="numm=1">
          <a href="#">奖项荣誉</a>
        </li>
        <li :class="{active:2==numm}" @click="numm=2">
          <a href="#">商企资讯</a>
        </li>
        <li :class="{active:3==numm}" @click="numm=3">
          <a href="#">联系我们</a>
        </li>
      </ul>
    </div>
    <!-- num==0 -->
    <div class="content" v-show="numm==0">
      <div class="content_one">
        <h2>关于商企服</h2>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;商企服由商汇天津信息技术有限公司开发，商企服平台为企业提供“商业服务商城、政务、商会、商机、人脉”等五个方面综合性服务。通过为商会提供会员管理服务系统进行平台流量导入，通过为商业服务类公司提供线上店铺入驻及CRM系统增加平台用户粘度，并使线下流量上行。项目现在已经研发完成并上线运营，并与天津市河西区、天津市河东区、甘肃省庆阳市等工商联达成战略合作。</p>
        <p
          class="content_one_p"
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;商汇（天津）信息技术有限公司是在历史的机遇下，结合习近平总书记在北京人民大会堂主持召开民营企业座谈会并发表重要讲话等政策和深厚的技术及资源背景孕育而生的，公司主要是进行一站式企业服务平台“商企服”建设运营及帮助各地政府进行线上民营企业服务平台及线下民营企业服务中心建设运营。</p>
        <div class="content_one_img">
          <img src="../../assets/img/guanyu/about_img_data01.png" alt />
          <img src="../../assets/img/guanyu/about_img_data02.png" alt />
          <img src="../../assets/img/guanyu/about_img_data03.png" alt />
        </div>
      </div>
      <div class="content_two">
        <div class="content_two_1">
          <div class="content_two_left">
            <img src="../../assets/img/guanyu/about_sign_logo.png" alt />
            <h2>平台为企业提供</h2>
            <p>利用移动互联网技术，整合政府资源和社会资源，有效解决政府服务众多民营企业不到位、民营企业间与社会资源信息不对称等难点、痛点问题，真正为民营企业发展提供便捷、综合的服务。</p>
            <p>最终为企业提供AI一键服务，实现“一呼百应”的效果。</p>
          </div>
          <div class="content_two_right">
            <img src="../../assets/img/guanyu/about_img_support.png" alt />
          </div>
        </div>
      </div>
      <div class="content_tree">
        <div class="content_tree_1">
          <h2>未来愿景</h2>
          <img src="../../assets/img/guanyu/about_img_vision.png" alt />
        </div>
      </div>
      <div class="content_four">
        <div class="content_four_1">
          <h2>服务与合作</h2>
          <div class="content_four_2" style="margin-left:0;">
            <div class="content_four_21">
              <img src="../../assets/img/guanyu/about_icon_sh.png" alt />
              <p class="foue_p">商会合作</p>
              <p style="font-size:14px; color:#666666;">帮助商会实现对会员的吸纳管理、内容发布、消息互动、活动通知、数据分析等</p>
              <p>
                <a href="#">立即了解</a>
                <img src="../../assets/img/guanyu/about_btn_see.png" alt />
              </p>
            </div>
          </div>
          <div class="content_four_2">
            <div class="content_four_21">
              <img src="../../assets/img/guanyu/about_icon_fws.png" alt />
              <p class="foue_p">服务商合作</p>
              <p style="font-size:14px; color:#666666;">免费为服务商提供CRM系统及线上店铺入驻。帮助服务商进行客户管理、线下收款及客户营销</p>
              <p>
                <a href="#">立即了解</a>
                <img src="../../assets/img/guanyu/about_btn_see.png" alt />
              </p>
            </div>
          </div>
          <div class="content_four_2">
            <div class="content_four_21">
              <img src="../../assets/img/guanyu/about_icon_dls.png" alt />
              <p class="foue_p">代理商合作</p>
              <p style="font-size:14px; color:#666666;" class="four_P">共同开发客户资源，享受服务返佣</p>
              <p>
                <a href="#">立即了解</a>
                <img src="../../assets/img/guanyu/about_btn_see.png" alt />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- num==1 -->
    <div class="content1" v-show="numm==1" id="tab1" name="tab1" ref="tab1">
      <div class="content1_1">
        <img src="../../assets/img/guanyu/about_img_honour01.png" alt />
        <img src="../../assets/img/guanyu/about_img_honour02.png" alt />
      </div>
    </div>
    <!-- num==2 -->
    <div class="content2" v-show="numm==2">
      <div class="content2_1">
        <div class="content2_top">
          <ul>
            <li :class="{activer:0==num}" @click="num=0">
              <a href="#">新闻资讯</a>
            </li>
          </ul>
        </div>
        <div class="content2_botoom" v-show="num==0">
          <div class="content2_botoom_1" v-for="(item,index) in lists" :key="index">
            <router-link
              :to="{path:'/zixun',query:{id:item.id}}"
              tag="div"
              class="content2_botoom_2"
            >
              <div class="content2_botoom_img">
                <img :src="'https://coc.sqifu.com/'+item.img" alt />
              </div>
              <div class="content2_botoom_right">
                <p class="content2_botoom_one">
                  <a href="#">{{item.article_name}}</a>
                </p>
                <p class="content2_botoom_two" v-html="item.text">{{showHtml(item.text)}}</p>
                <p class="content2_botoom_tree">{{item.update_time}}</p>
              </div>
            </router-link>
          </div>
          <div class="content_right_fenye">
            <el-pagination
              class="fenye"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              background
              layout="prev, pager, next"
              :total="total"
            >
              <!-- @size-change="handleSizeChange"  @current-change="handleCurrentChange" :current-page.sync="currentPage1" -->
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- num==3 -->
    <div class="content3" v-show="numm==3">
      <div class="content3_1">
        <ul>
          <li>
            <img src="../../assets/img/guanyu/contact_img_small routine.png" alt />
            <p class="li_pp">商企服小程序</p>
            <p>微信扫码进入小程序</p>
          </li>
          <li>
            <img src="../../assets/img/guanyu/contact_img_QR01.png" alt />
            <p class="li_pp">官方微信号</p>
            <p>扫码添加官方微信</p>
          </li>
          <li>
            <img src="../../assets/img/guanyu/contact_img_QR02.png" alt />
            <p class="li_pp">微信公众号</p>
            <p>扫码关注微信公众号</p>
          </li>
          <li>
            <img src="../../assets/img/guanyu/contact_img_tel.png" alt />
            <p class="li_pp">联系电话</p>
            <p>022 8821 9596</p>
          </li>
          <li>
            <img src="../../assets/img/guanyu/contact_img_location.png" alt />
            <p class="li_pp">总部地址</p>
            <p>天津市河西区陈塘庄尊华商务中心205室</p>
          </li>
        </ul>
        <div class="content3_ditu">
          <div id="allmap" ref="allmap"></div>
        </div>
      </div>
    </div>
    <!-- di'bu -->
    <div class="floor">
      <div class="floor_1">
        <img src="../../assets/img/bottom_logo_white.png" alt class="img" />
        <ul>
          <li>
            <a href="#">关于商企服</a>
          </li>
          <li @click="leimu()">
            <a href="#">商企服服务平台</a>
          </li>
          <li>
            <a href="#">|</a>
          </li>
          <li>
            <a href="#">联系电话：022-8821-9596</a>
          </li>
          <p>Copyright © 1998 - 2019 newcoc. All Rights Reserved.</p>
        </ul>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible" width="760px" height="473px">
      <div class="login1">
        <div :class="{active:0==num}" @click="num=0">
          <a href="#">登录</a>
        </div>
        <div :class="{active:1==num}" @click="num=1">
          <a href="#">注册</a>
        </div>
      </div>
      <div class="login1_1" v-show="num==0">
        <img src="../../assets/img/pop_bg_login.png" alt class="login1_img" />
        <div class="login1_2">
          <div class="login1_2_left">
            <div class="login1_2_erro1">
              <div class="login1_2_erro" v-show="cang">
                <img src="../../assets/img/pop_icon_error.png" alt />
                <p>手机号格式错误！</p>
              </div>
            </div>
            <div class="login1_2_login">
              <div class="login1_2_tel">
                <el-form>
                  <el-form-item prop="phone" class="pr">
                    <el-input placeholder="请输入手机号" class="input1" v-model="form.phone"></el-input>
                    <button @click="getCode(form)" class="code-btn" :disabled="!show">
                      <span v-show="show">获取验证码</span>
                      <span v-show="!show" class="count">重新发送({{count}})</span>
                    </button>
                  </el-form-item>
                  <el-form-item class="pr" prop="ecord">
                    <el-input placeholder="请输入验证码" class="input1" v-model="form.ecord"></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <div class="login1_2_denglu" @click="login()">
                <p>
                  <a href="#">登录</a>
                </p>
              </div>
            </div>
          </div>
          <!-- <div class="login1_2_right">
            <img src alt />
          </div>-->
        </div>
      </div>
      <div class="login2_1" v-show="num==1">
        <div class="login2_1_one">
          <div class="login1_2_erro1">
            <div class="login1_2_erro" v-show="cang">
              <img src="../../assets/img/pop_icon_error.png" alt />
              <p>手机号格式错误！</p>
            </div>
          </div>
          <div class="login2_1_two">
            <el-form>
              <el-form-item class="pr" prop="name">
                <el-input placeholder="请输入姓名" class="input1" v-model="formLogon.name"></el-input>
              </el-form-item>
              <el-form-item prop="phone" class="pr">
                <el-input placeholder="请输入手机号" class="input1" v-model="formLogon.phone"></el-input>
                <button @click="getCode1(formLogon)" class="code-btn" :disabled="!show">
                  <span v-show="show">获取验证码</span>
                  <span v-show="!show" class="count">重新发送({{count}})</span>
                </button>
              </el-form-item>
              <el-form-item class="pr" prop="ecord">
                <el-input placeholder="请输入验证码" class="input1" v-model="formLogon.ecord"></el-input>
              </el-form-item>
              <el-form-item class="pr" prop="enterprise_name">
                <el-input placeholder="请输入公司名称" class="input1" v-model="formLogon.enterprise_name"></el-input>
              </el-form-item>
              <el-form-item class="pr">
                <el-cascader
                  :options="options"
                  :props="defaultParams"
                  :change-on-select="true"
                  :clearable="true"
                  v-model="formLogon.office_address_province_id"
                  @change="handleChange"
                  ref="cascaderAddr"
                  style="width:322px"
                ></el-cascader>
              </el-form-item>
              <el-form-item class="pr" prop="detailed_address">
                <el-input
                  placeholder="请输入公司详细地址"
                  class="input1"
                  v-model="formLogon.detailed_address"
                ></el-input>
              </el-form-item>
            </el-form>
            <div class="login_three">
              <img src="../../assets/img/pop_btn_xy_nor.png" @click="munn()" v-show="num1==2" />
              <img src="../../assets/img/pop_btn_xy_sel.png" @click="munn1()" v-show="num1==1" />
              <p>
                我已阅读并同意
                <a href="#" style="color:#007BFF">《商企服平台用户服务协议》</a>
              </p>
            </div>
            <div class="login1_2_denglu" @click="getlogon">
              <p>
                <a href="#">注册</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible1" width="760px" height="473px">
      <div class="login1">
        <div :class="{active:1==num}" @click="num=1">
          <a href="#">登录</a>
        </div>
        <div :class="{active:0==num}" @click="num=0">
          <a href="#">注册</a>
        </div>
      </div>
      <div class="login1_1" v-show="num==1">
        <img src="../../assets/img/pop_bg_login.png" alt class="login1_img" />
        <div class="login1_2">
          <div class="login1_2_left">
            <div class="login1_2_erro1">
              <div class="login1_2_erro" v-show="cang">
                <img src="../../assets/img/pop_icon_error.png" alt />
                <p>手机号格式错误！</p>
              </div>
            </div>
            <div class="login1_2_login">
              <div class="login1_2_tel">
                <el-form>
                  <el-form-item prop="phone" class="pr">
                    <el-input placeholder="请输入手机号" class="input1" v-model="form.phone"></el-input>
                    <button @click="getCode(form)" class="code-btn" :disabled="!show">
                      <span v-show="show">获取验证码</span>
                      <span v-show="!show" class="count">重新发送({{count}})</span>
                    </button>
                  </el-form-item>
                  <el-form-item class="pr" prop="ecord">
                    <el-input placeholder="请输入验证码" class="input1" v-model="form.ecord"></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <div class="login1_2_denglu" @click="login()">
                <p>
                  <a href="#">登录</a>
                </p>
              </div>
            </div>
          </div>
          <!-- <div class="login1_2_right">
            <img src alt />
          </div>-->
        </div>
      </div>
      <div class="login2_1" v-show="num==0">
        <div class="login2_1_one">
          <div class="login1_2_erro1">
            <div class="login1_2_erro" v-show="cang">
              <img src="../../assets/img/pop_icon_error.png" alt />
              <p>手机号格式错误！</p>
            </div>
          </div>
          <div class="login2_1_two">
            <el-form>
              <el-form-item class="pr" prop="name">
                <el-input placeholder="请输入姓名" class="input1" v-model="formLogon.name"></el-input>
              </el-form-item>
              <el-form-item prop="phone" class="pr">
                <el-input placeholder="请输入手机号" class="input1" v-model="formLogon.phone"></el-input>
                <button @click="getCode1(formLogon)" class="code-btn" :disabled="!show">
                  <span v-show="show">获取验证码</span>
                  <span v-show="!show" class="count">重新发送({{count}})</span>
                </button>
              </el-form-item>
              <el-form-item class="pr" prop="ecord">
                <el-input placeholder="请输入验证码" class="input1" v-model="formLogon.ecord"></el-input>
              </el-form-item>
              <el-form-item class="pr" prop="enterprise_name">
                <el-input placeholder="请输入公司名称" class="input1" v-model="formLogon.enterprise_name"></el-input>
              </el-form-item>
              <el-form-item class="pr">
                <el-cascader
                  :options="options"
                  :props="defaultParams"
                  :change-on-select="true"
                  :clearable="true"
                  v-model="formLogon.office_address_province_id"
                  @change="handleChange"
                  ref="cascaderAddr"
                  style="width:322px"
                ></el-cascader>
              </el-form-item>
              <el-form-item class="pr" prop="detailed_address">
                <el-input
                  placeholder="请输入公司详细地址"
                  class="input1"
                  v-model="formLogon.detailed_address"
                ></el-input>
              </el-form-item>
            </el-form>
            <div class="login_three">
              <img src="../../assets/img/pop_btn_xy_nor.png" @click="munn()" v-show="num1==2" />
              <img src="../../assets/img/pop_btn_xy_sel.png" @click="munn1()" v-show="num1==1" />
              <p>
                我已阅读并同意
                <a href="#" style="color:#007BFF">《商企服平台用户服务协议》</a>
              </p>
            </div>
            <div class="login1_2_denglu" @click="getlogon">
              <p>
                <a href="#">注册</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getArticleList } from "@/http/api";
import { getLoginphone, getLogin, getRegionList, getLogon } from "@/http/api";
export default {
  data() {
    return {
      value1: "",
      numm: 0,
      num: 0,
      lists: [],
      total: 0,
      listss: 0,
      total: 0,
      currentPage: 1, //初始页
      //登录
      dialogVisible: false,
      dialogVisible1: false,
      num: 0,
      TIME_COUNT: 60, //验证码倒计时60s
      form: {
        phone: "",
        ecord: ""
      },
      formLogon: {
        phone: "",
        ecord: "",
        name: "",
        enterprise_name: "",
        office_address_province_id: "",
        detailed_address: ""
      },
      count: "",
      show: true,
      cang: false,
      num1: 2,
      options: [],
      defaultParams: {
        label: "name",
        value: "id",
        children: "children"
      },
      //划过
      munn() {
        this.num1 = 1;
      },
      munn1() {
        this.num1 = 2;
      },
      getCitys:[]
    };
  },
  methods: {
    showHtml: function(str) {
      return str
        .replace(str ? /&(?!#?\w+;)/g : /&/g, "&amp;")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'");
    },
    // 初始页currentPage、初始每页数据数pagesize和数据data
    handleCurrentChange: function(currentPage) {
      this.currentPage = currentPage;
      this.getArticlelist(currentPage);
      console.log(this.currentPage); //点击第几页
    },
    // 跳转
    leimu() {
      this.$router.push({ name: "home" });
    },
    map() {
      let map = new BMap.Map(this.$refs.allmap);
      map.centerAndZoom(new BMap.Point(117.253238, 39.090906), 11);
      map.addControl(
        new BMap.MapTypeControl({
          mapTypes: [BMAP_NORMAL_MAP, BMAP_HYBRID_MAP]
        })
      );
      map.setCurrentCity("天津");
      map.enableScrollWheelZoom(true);
    },
    getArticlelist(page) {
      getArticleList({ page: page }).then(res => {
        this.lists = res.data.data.list;
        this.total = res.data.data.count;
      });
    },
    //登录
    getCode(form) {
      if (!/^1[34578]\d{9}$/.test(this.form.phone)) {
        this.cang = !this.cang;
      } else if (/^1[34578]\d{9}$/.test(this.form.phone)) {
        this.cang = false;
        getLoginphone({ phone: this.form.phone }).then(res => {
          console.log(res);
        });
        if (!this.timer) {
          this.count = this.TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= this.TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      }
    },
    login() {
      if (this.form.ecord == "") {
        this.$message({
          message: "请输入验证码"
        });
      } else {
        getLogin({
          phone: this.form.phone,
          ecord: this.form.ecord
        }).then(res => {
          console.log(res);
          this.login_login = res.data;
          console.log(this.login_login);
          if (res.data.errcode === 200) {
            this.dialogVisible = false;
            this.$message({
              message: "登录成功",
              type: "success"
            });
            this.$router.push({
              name: "home",
              query: {
                id: res.data.data.name,
                idimg: res.data.data.photo,
                token: res.data.data.token
              }
            });
            localStorage.setItem("name", res.data.data.name);
            localStorage.setItem("token", res.data.data.token);
            localStorage.setItem("phone", res.data.data.phone);
            localStorage.setItem("photo", res.data.data.photo);
            localStorage.setItem("member_id", res.data.data.member_id);
            localStorage.setItem("is_service", res.data.data.is_service);
          } else if (res.data.errcode == 406) {
            this.$message({
              message: "账号信息不存在，请先注册"
            });
          }
        });
      }
    },
    //注册并登录
    getCode1(formLogon) {
      if (!/^1[34578]\d{9}$/.test(this.formLogon.phone)) {
        this.cang = !this.cang;
      } else if (/^1[34578]\d{9}$/.test(this.formLogon.phone)) {
        this.cang = false;
        getLoginphone({ phone: this.formLogon.phone }).then(res => {
          console.log(res);
        });
        if (!this.timer) {
          this.count = this.TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= this.TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      }
    },
    getlogon() {
      getLogon({
        name: this.formLogon.name,
        phone: this.formLogon.phone,
        ecord: this.formLogon.ecord,
        enterprise_name: this.formLogon.enterprise_name,
        office_address_province_id: this.formLogon.office_address_province_id,
        detailed_address: this.formLogon.detailed_address
      }).then(res => {
        this.logon_logon = res.data.errcode;
        if (res.data.errcode == 200) {
          this.$router.push({
            name: "home",
            query: {
              id: this.formLogon.name
            }
          });
          localStorage.setItem("name", this.formLogon.name);
          localStorage.setItem("is_service", res.data.data.is_service);
        }
        if (res.data.errcode === 20001) {
          this.$message({
            message: "该手机号已经是会员",
            type: "success"
          });
        }
      });
    },
    handleChange(value) {
      console.log(value);
      let labels = this.$refs["cascaderAddr"].currentLables;
      console.log(this.$refs["cascaderAddr"]);
    },
    getRegion() {
      getRegionList({}).then(res => {
        console.log(res);
        this.options = res.data.data;
      });
    },
    checlogin() {
      this.token = localStorage.getItem("token");
      this.$http(
        "https://coc.sqifu.com/WebProgram/Base/checklogin",
        {
          token: this.token
        },
        "post"
      ).then(res => {
        if (res.data.errcode === 20001) {
          this.$emit("header", false); //是否显示头部
        } else {
          this.$emit("header", true); //是否显示头部
        }
      });
    },
    getCity() {
      this.$http("https://ctapi.sqifu.com/api/v1/getCityList", {}, "post").then(
        res => {
          this.getCitys = res.data.data;
        }
      );
    },
    dropdown(id, index) {
      this.citr = index;
      localStorage.setItem("city_id", id);
      localStorage.setItem("citr", this.citr);
      this.$router.go(0);
    }
  },
  mounted() {
    this.map();
  },
  created() {
    this.getArticlelist();
    this.getRegion(); //城市
    this.checlogin();
    var numm = this.$route.query.numm;
    this.citr = localStorage.getItem("citr");
    this.getCity();
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
}

.warp {
  width: 100%;
  height: auto;
  position: relative;
  overflow: hidden;
}

.top {
  width: 100%;
  background: #f5f6fa;
}

.top_cent {
  width: 1200px;
  height: 40px;
  margin: 0 auto;
}

.aa {
  color: #222222;
}

.top_p {
  font-size: 14px;
  color: #222222ff;
  line-height: 40px;
  float: left;
}

.top_p p {
  float: left;
  padding: 0 12px;
}

.top_cent_p {
  color: #007bffff;
  float: left;
}

.icon {
  color: #000;
}

.top_ul {
  width: auto;
  height: auto;
  display: flex;
  float: right;
}

.top_ul li {
  font-size: 14px;
  line-height: 40px;
  color: #666666;
  margin-left: 39px;
}
.top_ul li a {
  color: #666666;
}
.warp1 {
  width: 100%;
  margin: 0 auto;
  z-index: 1;
  overflow: hidden;
  min-width: 1200px;
}

.floor {
  width: 100%;
  height: 139px;
  background: #2d3236;
  overflow: hidden;
}

.floor_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
}

.img {
  padding: 54px 0;
  float: left;
}

.floor_1 ul {
  width: 480px;
  height: 96px;
  float: right;
  padding: 44px 0;
}

.floor_1 ul li a {
  float: left;
  padding: 0 0 0 33px;
  color: #ffffff;
  font-size: 14px;
}
.floor_1 ul p {
  font-size: 14px;
  font-weight: 400;
  float: right;
  color: #85919aff;
  padding: 20px 0;
}

.banner {
  width: 100%;
  height: 360px;
  background: blue;
  position: relative;
}

.content {
  width: 100%;
}

.content_1 {
  width: 1200px;
  margin: 0 auto;
}

.cent {
  width: 100%;
  height: 60px;
  background: #f5f6fa;
}

.content_ul {
  width: 1200px;
  margin: 0 auto;
  display: flex;
}

.content_ul li {
  width: 25%;
  line-height: 60px;
  text-align: center;
}

.content_ul li a {
  color: #222222;
}

.content_one {
  width: 1200px;
  height: 559px;
  margin: 0 auto;
}

.content_one h2 {
  text-align: center;
  padding: 60px 0;
}

.content_one p {
  color: #666666;
  line-height: 30px;
}

.content_one_p {
  padding: 50px 0;
}

.content_one_img img {
  padding: 0 0 0 55px;
}

.content_one_img img:first-child {
  padding: 0;
}

.content_two {
  width: 100%;
  height: 588px;
  background: #f7f6fb;
}

.content_two_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
  overflow: hidden;
}

.content_two_left {
  width: 480px;
  height: auto;
  float: left;
  margin: 94px 0 0 0;
}

.content_two_left img,
.content_two_left h2,
.content_two_left p {
  padding: 0 0 35px 0;
}

.content_two_left p {
  color: #666666;
  line-height: 30px;
}

.content_two_right img {
  float: right;
  padding: 60px 0;
}

.content_tree {
  width: 100%;
  height: 651px;
}

.content_tree_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
}

.content_tree_1 h2,
.content_four_1 h2 {
  text-align: center;
  padding: 96px 0 0 0;
}

.content_four {
  width: 100%;
  height: 553px;
  background: #f7f6fb;
}

.content_four_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
}

.content_four_2 {
  width: 380px;
  height: 262px;
  background: #fff;
  margin-top: 71px;
  overflow: hidden;
  float: left;
  margin-left: 30px;
}

.content_four_21 {
  width: 321px;
  height: auto;
  margin: 24px auto;
}

.content_four_21 p {
  line-height: 25px;
  padding: 12px 0;
}

.content_four_21 p:first-child {
  font-size: 18px;
  font-weight: 600;
}

.foue_p {
  font-size: 18px;
  color: #222222;
  font-weight: 600;
}

.content_four_21 p a {
  color: #067eff;
  font-size: 14px;
  padding: 0;
}

.four_P {
  width: auto;
  height: 48px;
}

.content_ul li.active {
  background: #fff;
}

.content_ul li.active a {
  color: #007bff;
}

.content1 {
  width: 100%;
  height: auto;
}

.content1_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
}

.content1_1 img {
  padding: 94px 0 0 0;
}

.content1_1 img:last-child {
  padding: 80px 0 140px 0;
}

.content2 {
  width: 100%;
  height: auto;
}

.content2_1 {
  width: 1000px;
  height: auto;
  margin: 0 auto;
  margin-bottom: 50px;
}

.content2_top {
  width: 100%;
  height: 86px;
  border-bottom: 1px solid #e4e4e4;
}

.content2_top ul {
  width: 106px;
  height: 86px;
  margin: 0 auto;
}

.content2_top ul li {
  width: 106px;
  height: 82px;
  font-size: 24px;
  line-height: 82px;
}

.content2_top ul li a {
  color: #222222;
}

.content2_top ul li.activer {
  border-bottom: 5px solid #007bff;
}

.content2_top ul li.activer a {
  color: #007bff;
}

.content2_botoom {
  width: 100%;
  height: 1650px;
}

.content2_botoom_1 {
  width: 100%;
  height: 191px;
  border-bottom: 1px solid #e4e4e4;
  overflow: hidden;
}

.content2_botoom_2 {
  width: 100%;
  height: 131px;
  margin: 30px auto;
}

.content2_botoom_img {
  width: 208px;
  height: 131px;
  /* background: #000; */
  float: left;
}

.content2_botoom_img img {
  width: 208px;
  height: 131px;
}

.content2_botoom_right {
  width: 752px;
  float: right;
}

.content2_botoom_one {
  width: 576px;
  font-size: 24px;
  font-weight: 400;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.content2_botoom_one a {
  color: #222;
}

.content2_botoom_two {
  font-size: 14px;
  color: #666666;
  padding: 18px 0 0 0;
  display: -webkit-box;
  overflow: hidden;
  white-space: normal !important;
  text-overflow: ellipsis;
  word-wrap: break-word;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.content2_botoom_tree {
  color: #999;
  font-size: 14px;
  padding: 10px 0 0 0;
}

.content_right_fenye {
  width: 100%;
  overflow: hidden;
  text-align: center;
  padding: 35px 0;
}

.content2_botoom_one a:hover {
  color: #007bff;
}

.content3 {
  width: 100%;
  height: auto;
}

.content3_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
}

.content3_1 ul {
  display: flex;
  flex-wrap: wrap;
  margin-top: 30px;
  margin-bottom: 50px;
}

.content3_1 ul li {
  width: 380px;
  height: 160px;
  margin-top: 30px;
  margin-left: 20px;
  position: relative;
}

.content3_1 ul li img {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.content3_1 ul li p {
  padding-left: 53px;
}

.li_pp {
  padding: 55px 0 0 53px;
  font-weight: 600;
  margin-bottom: 10px;
}

.content3_ditu {
  width: 100%;
  height: 460px;
  margin-bottom: 100px;
}

#allmap {
  height: 460px;
  width: 97%;
  overflow: hidden;
  margin: 0 auto;
}
#result {
  width: 100%;
  font-size: 12px;
}

.banner_1 {
  width: 1200px;
  height: 360px;
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -600px;
}

.banner_1 img {
  padding: 40px 0;
  margin-bottom: 10px;
}

.banner_1 p {
  color: #fff;
  line-height: 50px;
}

.banner_p {
  font-size: 40px;
}

/* denglu */
.login1 {
  width: 340px;
  height: 50px;
  margin: 0 auto;
}

.login1 div {
  width: 170px;
  height: 40px;
  font-size: 18px;
  float: left;
  text-align: center;
  font-weight: bold;
  border-bottom: 2px solid #e4e4e4;
}

.login1 div a {
  color: #a9a9a9;
}

.login1 div.active {
  border-bottom: 2px solid #007bff;
}

.login1 div.active a {
  color: #007bff;
}

.login1_1 {
  width: 100%;
  height: 399px;
  position: relative;
  overflow: hidden;
}

.login1_img {
  position: absolute;
  right: 0;
  bottom: 0;
}

.login1_2 {
  width: 604px;
  height: 239px;
  margin: 50px auto;
}

.login1_2_left {
  width: 332px;
  height: auto;
  margin: 0 auto;
}

.login1_2_erro {
  width: 322px;
  height: 30px;
  border: 1px solid#FF4D42;
  background: rgba(255, 77, 66, 0.1);
  line-height: 30px;
  margin-bottom: 16px;
}

.login1_2_erro1 {
  width: 322px;
  height: 30px;
  margin-bottom: 16px;
}

.login1_2_erro img {
  float: left;
  padding: 5px 9px;
}

.login1_2_login {
  width: 322px;
  height: 168px;
}

.inp {
  width: 210px;
  height: 40px;
  font-size: 14px;
  float: left;
  outline: 0;
  border: 0;
  margin: 0 5px;
}

.login1_2_tel {
  width: 100%;
  height: auto;
  margin-bottom: 30px;
  position: relative;
}

.inpt {
  width: 312px;
  height: 38px;
  outline: 0;
  font-size: 14px;
  border: 0;
  margin: 0 5px;
}

.login1_2_right {
  float: right;
  background: #000;
  width: 228px;
  height: 239px;
}

.login1_2_denglu {
  width: 100%;
  height: 40px;
  background: #007bff;
  margin-top: 32px;
}

.login1_2_denglu p {
  text-align: center;
  font-size: 16px;
  line-height: 40px;
}

.login1_2_denglu p a {
  color: #fff;
}
.code-btn {
  width: 100px;
  height: 20px;
  position: absolute;
  top: 10px;
  right: 5px;
  z-index: 222;
  color: #007bff;
  font-size: 14px;
  border: none;
  border-left: 1px solid #bababa;
  padding-left: 10px;
  background-color: #fff;
  cursor: pointer;
  outline: none;
}
.pr {
  margin-bottom: 20px;
}

.login2_1_one {
  width: 322px;
  height: 550px;
  margin: 20px auto;
}

.login_three {
  width: 100%;
  height: 20px;
  margin-bottom: 20px;
}

.login_three img {
  float: left;
  padding: 0 5px 0 0;
}

.login_three p {
  float: left;
  line-height: 15px;
}

.top_ul li a {
  color: #666666;
}

.koa {
  width: auto;
  text-align: center;
  margin-top: -5px;
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/Guanyu/Guanyu.vue